import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, ArrowLeft } from "lucide-react";
import { api, setToken, formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const inputCls =
    "w-full bg-[#111111] border border-[#222] text-white placeholder:text-[#555] px-4 py-4 text-sm rounded-none focus:outline-none focus:ring-2 focus:ring-[#005EEA] focus:border-[#005EEA]";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-5" data-testid="login-page">
      <a href="/" className="absolute top-8 left-8 flex items-center gap-2 text-[#666] hover:text-white transition-colors font-mono-accent text-xs" data-testid="back-home">
        <ArrowLeft size={14} /> Home
      </a>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md border border-[#222] bg-[#0b0b0b] p-8 md:p-10"
      >
        <p className="font-mono-accent text-[#005EEA] text-xs mb-3">Coach Access</p>
        <h1 className="font-display text-white text-4xl leading-none mb-8">Sign in</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <input
            className={inputCls}
            type="email"
            placeholder="Email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
          />
          <input
            className={inputCls}
            type="password"
            placeholder="Password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
          />
          {error && (
            <p className="text-red-400 text-sm" data-testid="login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full font-mono-accent text-xs bg-[#005EEA] text-white px-6 py-5 flex items-center justify-center gap-2 hover:bg-[#0047b3] transition-colors disabled:opacity-60"
            data-testid="login-submit"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : "Enter Dashboard"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
